
import { updateAppConfig } from '#app'
import { defuFn } from '/Users/yuto.yasuoka/Project/chirashi-viewer/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "4e3c2282-79a3-4248-9180-b09da42752a1"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
